/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  ExportErrorTrackingDataPathParameters,
  GenerateFiltersForErrorTrackingPathParameters,
  GetErrorTrackingDataPathParameters,
  RecalculateErrorTrackingPathParameters,
  TLDeleteErrorTrackingsRequest,
  TLExportErrorTrackingRequest,
  TLExportErrorTrackingResponse,
  TLGenerateFiltersForErrorTrackingRequest,
  TLGenerateFiltersResponse,
  TLGetErrorTrackingRequest,
  TLGetErrorTrackingResponse,
  TLHTTPValidationError,
  TLRefreshErrorTrackingResponse,
  TLSuccessResponse,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Delete Error Trackings
 */
export const deleteErrorTrackings = (
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSuccessResponse>(
    {
      url: `/v2/data-harmonization/error-tracking`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: tLDeleteErrorTrackingsRequest,
      signal,
    },
    options,
  );
};

export const getDeleteErrorTrackingsQueryKey = (
  tLDeleteErrorTrackingsRequest?: BodyType<TLDeleteErrorTrackingsRequest>,
) => {
  return ['DELETE', 'v2', 'data-harmonization', 'error-tracking', tLDeleteErrorTrackingsRequest] as const;
};

export const getDeleteErrorTrackingsQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteErrorTrackings>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteErrorTrackings>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDeleteErrorTrackingsQueryKey(tLDeleteErrorTrackingsRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteErrorTrackings>>> = ({ signal }) =>
    deleteErrorTrackings(tLDeleteErrorTrackingsRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof deleteErrorTrackings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeleteErrorTrackingsQueryResult = NonNullable<Awaited<ReturnType<typeof deleteErrorTrackings>>>;
export type DeleteErrorTrackingsQueryError = ErrorType<TLHTTPValidationError>;

export function useDeleteErrorTrackings<
  TData = Awaited<ReturnType<typeof deleteErrorTrackings>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteErrorTrackings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteErrorTrackings>>,
          TError,
          Awaited<ReturnType<typeof deleteErrorTrackings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteErrorTrackings<
  TData = Awaited<ReturnType<typeof deleteErrorTrackings>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteErrorTrackings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteErrorTrackings>>,
          TError,
          Awaited<ReturnType<typeof deleteErrorTrackings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteErrorTrackings<
  TData = Awaited<ReturnType<typeof deleteErrorTrackings>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteErrorTrackings>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete Error Trackings
 */

export function useDeleteErrorTrackings<
  TData = Awaited<ReturnType<typeof deleteErrorTrackings>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteErrorTrackings>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteErrorTrackingsQueryOptions(tLDeleteErrorTrackingsRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Delete Error Trackings
 */
export const prefetchDeleteErrorTrackingsQuery = async <
  TData = Awaited<ReturnType<typeof deleteErrorTrackings>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteErrorTrackings>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDeleteErrorTrackingsQueryOptions(tLDeleteErrorTrackingsRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Delete Error Trackings
 */
export const invalidateDeleteErrorTrackings = async (
  queryClient: QueryClient,
  tLDeleteErrorTrackingsRequest: BodyType<TLDeleteErrorTrackingsRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getDeleteErrorTrackingsQueryKey(tLDeleteErrorTrackingsRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Error Tracking Data
 */
export const getErrorTrackingData = (
  { errorTrackingId }: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLGetErrorTrackingResponse>(
    {
      url: `/v2/data-harmonization/error-tracking/${errorTrackingId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLGetErrorTrackingRequest,
      signal,
    },
    options,
  );
};

export const getGetErrorTrackingDataQueryKey = (
  { errorTrackingId }: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest?: BodyType<TLGetErrorTrackingRequest>,
) => {
  return ['POST', 'v2', 'data-harmonization', 'error-tracking', errorTrackingId, tLGetErrorTrackingRequest] as const;
};

export const getGetErrorTrackingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetErrorTrackingDataQueryKey({ errorTrackingId }, tLGetErrorTrackingRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getErrorTrackingData>>> = ({ signal }) =>
    getErrorTrackingData({ errorTrackingId }, tLGetErrorTrackingRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: errorTrackingId !== null && errorTrackingId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetErrorTrackingDataQueryResult = NonNullable<Awaited<ReturnType<typeof getErrorTrackingData>>>;
export type GetErrorTrackingDataQueryError = ErrorType<TLHTTPValidationError>;

export function useGetErrorTrackingData<
  TData = Awaited<ReturnType<typeof getErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErrorTrackingData>>,
          TError,
          Awaited<ReturnType<typeof getErrorTrackingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetErrorTrackingData<
  TData = Awaited<ReturnType<typeof getErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErrorTrackingData>>,
          TError,
          Awaited<ReturnType<typeof getErrorTrackingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetErrorTrackingData<
  TData = Awaited<ReturnType<typeof getErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Error Tracking Data
 */

export function useGetErrorTrackingData<
  TData = Awaited<ReturnType<typeof getErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetErrorTrackingDataQueryOptions({ errorTrackingId }, tLGetErrorTrackingRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Error Tracking Data
 */
export const prefetchGetErrorTrackingDataQuery = async <
  TData = Awaited<ReturnType<typeof getErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { errorTrackingId }: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetErrorTrackingDataQueryOptions({ errorTrackingId }, tLGetErrorTrackingRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Error Tracking Data
 */
export const invalidateGetErrorTrackingData = async (
  queryClient: QueryClient,
  { errorTrackingId }: GetErrorTrackingDataPathParameters,
  tLGetErrorTrackingRequest: BodyType<TLGetErrorTrackingRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetErrorTrackingDataQueryKey({ errorTrackingId }, tLGetErrorTrackingRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Export Error Tracking Data
 */
export const exportErrorTrackingData = (
  { errorTrackingId }: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLExportErrorTrackingResponse>(
    {
      url: `/v2/data-harmonization/error-tracking/${errorTrackingId}/export`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLExportErrorTrackingRequest,
      signal,
    },
    options,
  );
};

export const getExportErrorTrackingDataQueryKey = (
  { errorTrackingId }: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest?: BodyType<TLExportErrorTrackingRequest>,
) => {
  return [
    'POST',
    'v2',
    'data-harmonization',
    'error-tracking',
    errorTrackingId,
    'export',
    tLExportErrorTrackingRequest,
  ] as const;
};

export const getExportErrorTrackingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof exportErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportErrorTrackingDataQueryKey({ errorTrackingId }, tLExportErrorTrackingRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportErrorTrackingData>>> = ({ signal }) =>
    exportErrorTrackingData({ errorTrackingId }, tLExportErrorTrackingRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: errorTrackingId !== null && errorTrackingId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ExportErrorTrackingDataQueryResult = NonNullable<Awaited<ReturnType<typeof exportErrorTrackingData>>>;
export type ExportErrorTrackingDataQueryError = ErrorType<TLHTTPValidationError>;

export function useExportErrorTrackingData<
  TData = Awaited<ReturnType<typeof exportErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportErrorTrackingData>>,
          TError,
          Awaited<ReturnType<typeof exportErrorTrackingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportErrorTrackingData<
  TData = Awaited<ReturnType<typeof exportErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportErrorTrackingData>>,
          TError,
          Awaited<ReturnType<typeof exportErrorTrackingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportErrorTrackingData<
  TData = Awaited<ReturnType<typeof exportErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export Error Tracking Data
 */

export function useExportErrorTrackingData<
  TData = Awaited<ReturnType<typeof exportErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportErrorTrackingDataQueryOptions(
    { errorTrackingId },
    tLExportErrorTrackingRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Error Tracking Data
 */
export const prefetchExportErrorTrackingDataQuery = async <
  TData = Awaited<ReturnType<typeof exportErrorTrackingData>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { errorTrackingId }: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportErrorTrackingData>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExportErrorTrackingDataQueryOptions(
    { errorTrackingId },
    tLExportErrorTrackingRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Export Error Tracking Data
 */
export const invalidateExportErrorTrackingData = async (
  queryClient: QueryClient,
  { errorTrackingId }: ExportErrorTrackingDataPathParameters,
  tLExportErrorTrackingRequest: BodyType<TLExportErrorTrackingRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getExportErrorTrackingDataQueryKey({ errorTrackingId }, tLExportErrorTrackingRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Generate Filters For Error Tracking
 */
export const generateFiltersForErrorTracking = (
  { errorTrackingId }: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLGenerateFiltersResponse>(
    {
      url: `/v2/data-harmonization/error-tracking/${errorTrackingId}/generate-filters`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLGenerateFiltersForErrorTrackingRequest,
      signal,
    },
    options,
  );
};

export const getGenerateFiltersForErrorTrackingQueryKey = (
  { errorTrackingId }: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest?: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
) => {
  return [
    'POST',
    'v2',
    'data-harmonization',
    'error-tracking',
    errorTrackingId,
    'generate-filters',
    tLGenerateFiltersForErrorTrackingRequest,
  ] as const;
};

export const getGenerateFiltersForErrorTrackingQueryOptions = <
  TData = Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGenerateFiltersForErrorTrackingQueryKey({ errorTrackingId }, tLGenerateFiltersForErrorTrackingRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>> = ({ signal }) =>
    generateFiltersForErrorTracking(
      { errorTrackingId },
      tLGenerateFiltersForErrorTrackingRequest,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: errorTrackingId !== null && errorTrackingId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GenerateFiltersForErrorTrackingQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateFiltersForErrorTracking>>
>;
export type GenerateFiltersForErrorTrackingQueryError = ErrorType<TLHTTPValidationError>;

export function useGenerateFiltersForErrorTracking<
  TData = Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
          TError,
          Awaited<ReturnType<typeof generateFiltersForErrorTracking>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateFiltersForErrorTracking<
  TData = Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
          TError,
          Awaited<ReturnType<typeof generateFiltersForErrorTracking>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateFiltersForErrorTracking<
  TData = Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Generate Filters For Error Tracking
 */

export function useGenerateFiltersForErrorTracking<
  TData = Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGenerateFiltersForErrorTrackingQueryOptions(
    { errorTrackingId },
    tLGenerateFiltersForErrorTrackingRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Generate Filters For Error Tracking
 */
export const prefetchGenerateFiltersForErrorTrackingQuery = async <
  TData = Awaited<ReturnType<typeof generateFiltersForErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { errorTrackingId }: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof generateFiltersForErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGenerateFiltersForErrorTrackingQueryOptions(
    { errorTrackingId },
    tLGenerateFiltersForErrorTrackingRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Generate Filters For Error Tracking
 */
export const invalidateGenerateFiltersForErrorTracking = async (
  queryClient: QueryClient,
  { errorTrackingId }: GenerateFiltersForErrorTrackingPathParameters,
  tLGenerateFiltersForErrorTrackingRequest: BodyType<TLGenerateFiltersForErrorTrackingRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    {
      queryKey: getGenerateFiltersForErrorTrackingQueryKey(
        { errorTrackingId },
        tLGenerateFiltersForErrorTrackingRequest,
      ),
    },
    options,
  );

  return queryClient;
};

/**
 * @summary Recalculate Error Tracking
 */
export const recalculateErrorTracking = (
  { errorTrackingId }: RecalculateErrorTrackingPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLRefreshErrorTrackingResponse>(
    { url: `/v2/data-harmonization/error-tracking/${errorTrackingId}/recalculate`, method: 'POST', signal },
    options,
  );
};

export const getRecalculateErrorTrackingQueryKey = ({ errorTrackingId }: RecalculateErrorTrackingPathParameters) => {
  return ['POST', 'v2', 'data-harmonization', 'error-tracking', errorTrackingId, 'recalculate'] as const;
};

export const getRecalculateErrorTrackingQueryOptions = <
  TData = Awaited<ReturnType<typeof recalculateErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: RecalculateErrorTrackingPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRecalculateErrorTrackingQueryKey({ errorTrackingId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recalculateErrorTracking>>> = ({ signal }) =>
    recalculateErrorTracking({ errorTrackingId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: errorTrackingId !== null && errorTrackingId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RecalculateErrorTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof recalculateErrorTracking>>>;
export type RecalculateErrorTrackingQueryError = ErrorType<TLHTTPValidationError>;

export function useRecalculateErrorTracking<
  TData = Awaited<ReturnType<typeof recalculateErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RecalculateErrorTrackingPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recalculateErrorTracking>>,
          TError,
          Awaited<ReturnType<typeof recalculateErrorTracking>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRecalculateErrorTracking<
  TData = Awaited<ReturnType<typeof recalculateErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RecalculateErrorTrackingPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recalculateErrorTracking>>,
          TError,
          Awaited<ReturnType<typeof recalculateErrorTracking>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRecalculateErrorTracking<
  TData = Awaited<ReturnType<typeof recalculateErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: RecalculateErrorTrackingPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recalculate Error Tracking
 */

export function useRecalculateErrorTracking<
  TData = Awaited<ReturnType<typeof recalculateErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { errorTrackingId }: RecalculateErrorTrackingPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecalculateErrorTrackingQueryOptions({ errorTrackingId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Recalculate Error Tracking
 */
export const prefetchRecalculateErrorTrackingQuery = async <
  TData = Awaited<ReturnType<typeof recalculateErrorTracking>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { errorTrackingId }: RecalculateErrorTrackingPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof recalculateErrorTracking>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getRecalculateErrorTrackingQueryOptions({ errorTrackingId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Recalculate Error Tracking
 */
export const invalidateRecalculateErrorTracking = async (
  queryClient: QueryClient,
  { errorTrackingId }: RecalculateErrorTrackingPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getRecalculateErrorTrackingQueryKey({ errorTrackingId }) }, options);

  return queryClient;
};
